import { ElectronApi } from '@/services/electron.api';
import { WatchfaceService } from '@/services/watchface';
import { xmlToAst } from '../xmlTool';
import genBinaryFile from '@/services/compiler-refactor';
import { testAccess } from '../fs/fs-extra.utils';
import { saveHashFile } from './saveHashFile';
import { getZipBlob } from './getZipBlob';
import { writeCapabilitySet } from '../capabilitySet';

export const compileAndExportBinFile = async (
  watchfacePath: string,
  beforeZip?: () => Promise<void>
) => {
  const fs = ElectronApi.fs;
  const path = ElectronApi.path;
  if (!fs || !path) throw 'fs基础文件不可用';
  console.time('导出表盘bin文件耗时');

  const service = new WatchfaceService(watchfacePath);
  const description = await service.description.getDescriptionData();
  const watchfaceAst = await service.manifest
    .readManifestXML()
    .then((r) => xmlToAst(r ?? ''));
  if (!description || !watchfaceAst) throw '表盘文件有误，无法导出';

  // 保存能力集
  await writeCapabilitySet(description, watchfaceAst, watchfacePath);

  // 生成bin文件
  // 首先清理旧文件
  const binFilePath = path.join(watchfacePath, 'resource.bin');
  const uidmap = path.join(watchfacePath, 'uidmap.map');
  for (const filename of [binFilePath, uidmap]) {
    // 如果存在，则先删除
    if (await testAccess(filename)) await fs.promises.unlink(filename);
  }
  const binPath = await genBinaryFile(watchfacePath, description, watchfaceAst);
  // 检查bin文件是否存在
  if (!binPath || !(await testAccess(binPath))) throw '未生成表盘bin文件';

  // 检查uidmap文件是否存在
  const uidmapPath = path.join(watchfacePath, 'uidmap.map');
  if (!(await testAccess(uidmapPath))) throw '未生成uidmap文件';

  // 保存hash文件
  await saveHashFile(watchfacePath);

  // 生成mwz文件
  if (beforeZip) await beforeZip();
  const mwzBlob = await getZipBlob(watchfacePath);

  console.timeEnd('导出表盘bin文件耗时');
  return {
    mwzBlob,
    binPath
  };
};
